module.exports = __webpack_public_path__ + "img/unresponsive.7d18015e.svg";